import InventarioAnimales from "./InventarioAnimales";
export default InventarioAnimales;
